// @flow
import * as React from 'react';
import StickyBox from 'react-sticky-box';
import { getItem } from 'utils/localStorage';

/* For some reason react-sticky-box doesn't seem use ComponentDidUpdate,
  so we're forcing a re-render via key */

const testMode = getItem('testMode');

const StickySidebar = ({
  offsetTop,
  offsetBottom,
  key,
  children
}: {
  offsetTop?: number,
  offsetBottom?: number,
  key?: string,
  children?: React.Node
}) =>
  testMode ? (
    <div>{children}</div>
  ) : (
    <StickyBox
      offsetTop={offsetTop}
      offsetBottom={offsetBottom}
      key={key || `react-sticky-box-${offsetTop || 0}-${offsetBottom || 0}`}
    >
      {children}
    </StickyBox>
  );

export default StickySidebar;
